document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    let variants = document.getElementsByClassName("swatch-element");
    for (let i = 0; i < variants.length; i++) {
      variants[i].addEventListener("click", () => handleVariantChange());
    }

    var dropdown = document.getElementById("productQuantityDropdown");
    if (dropdown) {
      dropdown.addEventListener("change", () => handleQuantityChange());
      const handleQuantityChange = () => {
        const selectedQuantity = dropdown.value;
        console.log("DEBUG :: selected quantity:", selectedQuantity);
        const breezeButton = document.querySelector("breeze-button");
        breezeButton.setAttribute("productquantity", selectedQuantity);
        const breezeQuantity = breezeButton.getAttribute("productquantity");
        console.log("DEBUG :: breeze quantity:", breezeQuantity);
        // setTimeout(() => {
        //   const breezeButton = document.querySelector('breeze-button');
        //   breezeButton.setAttribute('productquantity', selectedQuantity);
        //   const breezeQuantity = breezeButton.getAttribute('productquantity');
        //   console.log("DEBUG :: breeze quantity:", breezeQuantity);
        // }, 0);
      };
    }

    const handleVariantChange = () => {
      setTimeout(() => {
        const nativeButton = document.getElementsByClassName(
          "shopify-payment-button__button shopify-payment-button__button--unbranded"
        )[0];
        const isNativeDisabled = nativeButton.hasAttribute("disabled");
        if (isNativeDisabled) {
          document.getElementsByClassName("breeze_button")[0].style =
            "display:none !important";
        } else {
          document.getElementsByClassName("breeze_button")[0].style =
            " width: 100%; margin-bottom: 20px; flex-wrap: wrap; flex-grow: 1; flex-basis: 0; margin-left: auto; transition: linear 0.4s ease-in-out 0s; box-shadow: none; border-radius: 8px; margin-top: 0px; !important";
        }
      }, 0);
    };
  }, 0);
});
